module.exports = __webpack_public_path__ + "static/media/banner_img.bc7e3a14.png";